import React, { Component } from 'react';

import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import CustomBtn from "./CustomBtn"
import Folder from '../assets/Folder.svg'
import { withRouter } from 'react-router-dom'    

export const compon = withRouter(({ history, location }) =>{

})

class DescriptionCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            job: ""
        }
    }

    componentDidMount(){
        const history = this.props.history
        console.log(history)
        if (history.location.state != null){
            this.setState({
                job: history.location.state.description
            })
        }
    }

    handleSubmit = () => {

        console.log(JSON.stringify({
            "description": this.state.job
        }))
        fetch(process.env.REACT_APP_IP+'/desc', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "description": this.state.job
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson)

                this.setState({
                    show: false
                })
                this.props.history.push({
                    pathname: "match",
                    state: { 
                        res: responseJson,
                        description: this.state.job
                    }
                  });
              
            })
            ;

    }

    handleShow = () => {
        this.setState({
            show: true
        })
    }

    handleClose = () => {
        this.setState({
            show: false
        })
    }

    handleChange = (event) => {
        this.props.handleChanges(event.target.value)
        this.setState({
            job: event.target.value
        })

    }


    render() {
        return (
            <>
                <Card
                    bg="white"
                    text="black"
                    className="text-center pt-5 mt-5 mb-5 shadow bg-white"
                    style={{ width: '150px', height: '180px', borderRadius: '25px' }}>
                    <i
                        className="material-icons"
                        style={{
                            color: '#29479a',
                            marginTop: '-65px',
                            marginBottom: '20px',
                            fontSize: '40px',
                            cursor: 'pointer'
                        }}
                        onClick={this.handleShow}>
                        add_circle
                        </i>
                    <img src={Folder} alt='job' />
                    <div>
                        <strong style={{ fontFamily: 'Nunito', fontSize: '12px' }}>
                            Upload <br />Job Description
                            </strong>
                    </div>
                </Card>
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Job Description</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form
                            onSubmit={null}>
                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                <Form.Control
                                    as="textarea"
                                    placeholder="job description here"
                                    value={this.props.description}
                                    onChange={this.handleChange}
                                    rows={5} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <CustomBtn  
                        type='secondary'
                        width='20%' 
                        fntSize='15px' 
                        colorwhite={false} 
                        txt='close'
                        onClick={this.handleClose}/>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}



export default withRouter(DescriptionCard)